import { useTracking } from 'common/utils';
import { useRef, useState } from 'react';
import { useChatContext } from 'src/pages/cropwise-ai/cropwise-ai-chat.context';

export const useCropwiseAiInput = () => {
  const [value, setValue] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const { sendMessage, sendAudioMessage, isLoading } = useChatContext();
  const { track } = useTracking();
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const chunksRef = useRef<Blob[]>([]);

  const handleSendMessage = async (message: string) => {
    if (!message.trim()) return;
    setValue('');
    await sendMessage(message);
    track('Cropwise AI - Message Sent');
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      chunksRef.current = [];
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        stream.getTracks().forEach((track) => track.stop());
        const blob = new Blob(chunksRef.current, {
          type: mediaRecorder.mimeType || 'audio/webm',
        });
        void sendAudioMessage(blob);
      };

      mediaRecorder.start();
      setIsRecording(true);
    } catch {
      setIsRecording(false);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  return {
    isPending: isLoading,
    handleSendMessage,
    startRecording,
    stopRecording,
    isRecording,
    value,
    setValue,
  };
};
